import React, { FC } from 'react';
import Breadcrumbs from '@mos-front-components/public/es/components/Breadcrumbs';
import Button from '@components/Button';

import Name from './private/Name';
import Special from './private/Special';
import Translation from './private/Translation';
import Description from './private/Description';
import Rating from './private/Rating';
import Address from './private/Address';
import Undergrounds from './private/Undergrounds';
import Schedule from './private/Schedule';
import Phone from './private/Phone';
import Workload from './private/Workload';
import CloseInfo from './private/CloseInfo';
import MobileShowMapBtn from './private/MobileShowMapBtn';
import MetaData from './private/MetaData';

import st from './DetailedInfo.module.css';

type DetailedInfoProps = {
  office: OfficeTypeProps;
  phone: boolean;
  onServicesCatalogOpen: () => void;
};

const DetailedInfo: FC<DetailedInfoProps> = ({
  office,
  phone,
  onServicesCatalogOpen,
}) => {
  const {
    rating,
    address,
    schedule,
    phoneNumber,
    status,
    id,
    description,
    translation,
    type,
    isVirtual,
  } = office;

  const breadcrumbs = [
    {
      url: `${window.location.origin}/services/`,
      name: 'Услуги',
    },
    {
      url: `${window.location.origin}/services/centry-gosudarstvennyh-uslug/`,
      name: 'Центры государственных услуг',
    },
    {
      name: office.name,
      url: `${window.location.href}`,
    },
  ];

  const mobileBreadcrumbs = [
    {
      url: `${window.location.origin}/services/centry-gosudarstvennyh-uslug/`,
      name: 'Центры государственных услуг',
    },
  ];

  const isClosed = status === 'CLOSE';

  return (
    <div className={st.container}>
      <MetaData office={office} />

      <Breadcrumbs
        breadcrumbs={phone ? mobileBreadcrumbs : breadcrumbs}
        className={st.breadcrumbs}
      />
      <Name isDetailed isClosed={isClosed} office={office} />
      {!isClosed ? (
        <div>
          <div className={st.icons}>
            {!isVirtual && <Rating isDetailed rating={rating} />}
            <Special isDetailed office={office} />
            <Translation
              isDetailed
              officeId={id}
              isDefaultOffice={type === 'default'}
              camerasUrl={translation}
            />
          </div>

          <Description description={description} />

          <div className={st.serviceButtonWrapper}>
            <Button onClick={onServicesCatalogOpen}>Выбрать услугу</Button>
          </div>

          <Address isDetailed isClosed={isClosed} address={address} />

          <MobileShowMapBtn isDetailed empty />

          <Schedule schedule={schedule} />

          <Phone isDetailed phone={phoneNumber} />

          <Undergrounds isDetailed address={address} />

          <Workload isDetailed officeId={id} schedule={schedule} />
        </div>
      ) : (
        <div>
          <Address isDetailed isClosed={isClosed} address={address} />
          <CloseInfo office={office} isDetailed />
        </div>
      )}
    </div>
  );
};

export default DetailedInfo;
